import React from "react"
import "./testimonial.css"

function Card(props) {
  return (
    <div className="cards">
      <div className="upper-container">
        <div className="image-container">
          <p>
            <img src={props.src} alt="" />
          </p>
        </div>
      </div>
      <div className="lower-container">
        <h3>{props.name}</h3>
        <h7>{props.position}</h7>
        <p>{props.content}</p>
      </div>
    </div>
  )
}
export default Card
